/**
 * ui/screens/Login — connexion (JWT). @author Dr Hamid MADANI <drmdh@msn.com>
 * AUTH-UI — candidat `@mostajs/auth-ui` (auth-stack, D15) : réutilisable par
 * TOUTES les apps (admin, guichet, distributeur, Salsabil, CRM, AOP).
 */
import React, { useState } from 'react';
import { useAuth } from '../AuthProvider';
import { makeT } from '../../engine/i18n';
import ServerPicker from '../ServerPicker';

export default function Login({ onServerChange, centralMode = false, siteLabel = '' }) {
  const { login } = useAuth();
  const [locale] = useState('fr');
  const t = makeT(locale);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err?.response?.status === 401 ? 'Identifiants invalides' : String(err?.message || err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="centered">
      <div className="card">
        <h1>{t('app.title')}</h1>
        {centralMode ? (
          <div className="server-picker">
            <label>Console centrale</label>
            <p className="muted">Site géré : <b>{siteLabel || '—'}</b></p>
          </div>
        ) : (
          <ServerPicker onChange={onServerChange} />
        )}
      </div>
      <form className="card" onSubmit={submit}>
        <h2>{t('login.title')}</h2>
        <label>{t('login.username')}</label>
        <input value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        <label>{t('login.password')}</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={busy || !username || !password}>{t('login.submit')}</button>
      </form>
    </div>
  );
}
